import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';
import BASEAPI from "@/util/BASEAPI";
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import OCTextBox from './OCTextBox.vue';
import OCFormLabel from './OCFormLabel.vue';
import OCRadioGroup from './OCRadioGroup.vue';
import OCRadio from './OCRadio.vue';
import OCButton from './OCButton.vue';
import { EmailPass } from '@/generated/api';

@Component({
    components: {
        OCTextBox, OCFormLabel, OCRadioGroup, OCRadio, OCButton
    },
})
export default class OCUserData extends Mixins(BASEComponentVue) {

    public zipError: string = "";

    public year: number = 1990;
    public month: number = 1;
    public day: number = 1;
    public daysMax: number = 1;

    public async getDays() {
        this.daysMax = new Date(this.year, this.month, 0).getDate();
        this.value.birthday = String(this.year) + "-" + String(('0' + this.month).slice(-2)) + "-" + String(('0' + this.day).slice(-2));
    }

    public async created() {
        this.getDays()
    }

    public async getBirthday() {
        this.year = Number(this.value.birthday.substring(0, 4));
        this.month = Number(this.value.birthday.substring(5, 7));
        this.day = Number(this.value.birthday.substring(8, 10));
    }

    @Prop({
        type: Object,
        default: (): BASEAPI.User => {
            return BASEAPI.user()
        },
    })
    public value!: BASEAPI.User;

    @Emit("input")
    public input(user: BASEAPI.User) {
        return user;
    };

    @Prop({
        type: String,
        default: ""
    })
    public type!: "edit" | "conf";

    public async getAddress() {
        if (this.value.zip == "" || this.value.zip.length != 7) {
            this.zipError = "正しい郵便番号を入力して下さい。";
            return;
        }

        if (this.value.zip.length == 7) {
            let geocoder = new google.maps.Geocoder();

            let res = await new Promise<google.maps.GeocoderResult[]>((resolve, reject) => {
                geocoder.geocode(
                    {
                        address: this.value.zip,
                        region: "JP",
                        componentRestrictions: {
                            postalCode: this.value.zip
                        }
                    },
                    (res, status) => {
                        if (typeof res === "string") {
                            reject();
                        } else {
                            resolve(res);
                        }
                    }
                );
            });

            if (!res) {
                this.zipError = "正しい郵便番号を入力して下さい。";
                return;
            }

            let geocoderResult: google.maps.GeocoderResult | null = null;
            for (const iterator of res) {
                if (iterator.types.indexOf("postal_code") == -1) {
                    continue;
                }
                geocoderResult = iterator;
            }
            if (!geocoderResult) {
                this.zipError = "正しい郵便番号を入力して下さい。";
                return
            }

            if (geocoderResult.types.indexOf("postal_code") == -1) {
                this.zipError = "正しい郵便番号を入力して下さい。";
                return;
            }
            let adress = "";
            for (let index = geocoderResult.address_components.length - 1; index >= 0; index--) {
                const component = geocoderResult.address_components[index];
                if (component.types.indexOf("political") == -1) continue;
                if (component.types.indexOf("country") > -1) continue;
                adress = adress + component.long_name;
            }
            this.zipError = "";
            this.value.address = adress;
        }
    }


}
